<template>
  <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
    <table class="table-fixed min-w-full divide-y divide-gray-200">
      <thead>
        <tr>
          <th
            v-for="column in tableColumns"
            :key="column.slug"
            scope="col"
            class="p-3 text-left text-xxs font-medium text-gray-500 uppercase tracking-wider"
          >
            {{ column.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in tableRows"
          :key="index"
          :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
        >
          <td
            class="p-4 text-xs font-medium text-vice-teal-900"
            v-for="(column, index) in tableColumns"
            :key="index"
          >
            <span v-if="row[index].type != 'url'">{{ row[index].data }}</span>
            <a
              v-else
              :href="route('session.user.details', row[index].data)"
              class="text-gray-500 hover:text-gray-400 flex py-3 px-1"
            >
              <ChevronRightIcon class="h-4 w-4"></ChevronRightIcon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ChevronRightIcon } from '@heroicons/vue/solid';

export default {
  components: {
    ChevronRightIcon,
  },
  props: {
    tableData: {
      type: Object,
      validator(value) {
        // Each table record should contain the mandatory keys:
        const requiredKeys = ['slug', 'name', 'data'];
        const propKeys = Object.keys(Object.values(value[0])[0]);
        return requiredKeys.every((key) => propKeys.includes(key));
      },
    },
  },

  computed: {
    tableColumns() {
      const columns = this.tableData[0].reduce((columnsWithSlug, column) => {
        if (column.slug) {
          columnsWithSlug.push({ slug: column.slug, name: column.name });
        }
        return columnsWithSlug;
      }, []);

      return columns;
    },
    tableRows() {
      return this.tableData;
    },
  },
};
</script>
